/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Body_Assessment_Consent_VersionInputs */

const en_us2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Permission text version ${i?.version}`)
};

const pt_br2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version} do texto de autorização`)
};

const es_419_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.version} del texto de permiso`)
};

const pt_pt2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version} do texto de autorização`)
};

const fr_fr2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} du texte d'autorisation`)
};

const de_de2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} des Erlaubnistexts`)
};

const it_it2_body_assessment_consent_version = /** @type {(inputs: Body_Assessment_Consent_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versione ${i?.version} del testo di consenso`)
};

/**
* | output |
* | --- |
* | "Permission text version {version}" |
*
* @param {Body_Assessment_Consent_VersionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_version = /** @type {((inputs: Body_Assessment_Consent_VersionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_VersionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_version(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_version(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_version(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_version(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_version(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_version(inputs)
	return en_us2_body_assessment_consent_version(inputs)
});
export { body_assessment_consent_version as "body-assessment.consent_version" }